import { apiClientAuth } from "../http/httpClient";


export function RepositoryApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {


        insert : (data) => https.post("/api/repository", data),

        updateOne : (id, data) => https.put(`/api/repository/${id}`, data),

        findAll : () => https.get(`/api/repository`),

        findOne : (id) => https.get(`/api/repository/${id}`),

        deleteOne : (id) => https.delete(`/api/repository/${id}`),

        share : (data) => https.post("/api/repository/share", data),

        findSharedRepo : (token) => https.get(`/api/repository/shared/${token}`),

        findLatest : () => https.get(`/api/repository/lasts`),

        
    };
}
